import { Flag } from "lucide-react";

export interface MercyBannerState {
  side: "us" | "them";
  runsRemaining: number;
  runsNeededToPrevent: number | null;
}

interface MercyBannerProps {
  warning: MercyBannerState | null;
  teamName: string;
  opponentName: string;
}

export function MercyBanner({
  warning,
  teamName,
  opponentName,
}: MercyBannerProps) {
  if (!warning) return null;

  const prevention = warning.runsRemaining === 0;
  const count = prevention
    ? warning.runsNeededToPrevent
    : warning.runsRemaining;
  if (count === null) return null;
  const leader = warning.side === "us" ? teamName : opponentName;
  const trailingTeam = warning.side === "us" ? opponentName : teamName;
  const name = prevention ? trailingTeam : leader;

  return (
    <div
      role="status"
      aria-label="Mercy rule pending"
      className="no-print bg-warning/12 font-mono text-[0.72rem] font-bold tracking-[0.08em] uppercase text-warning"
    >
      <div className="mx-auto flex min-h-9 max-w-[var(--content-width)] items-center justify-center gap-2 px-[max(0.75rem,var(--safe-left))] py-1 pr-[max(0.75rem,var(--safe-right))]">
        <Flag className="size-3.5 shrink-0" aria-hidden="true" />
        <span className="shrink-0">MERCY</span>
        <span aria-hidden="true">·</span>
        <span className="shrink-0">
          {count} {count === 1 ? "run" : "runs"} to{" "}
          {prevention ? "avoid mercy" : "mercy"}
        </span>
        <span aria-hidden="true">·</span>
        <span className="min-w-0 truncate text-foreground-muted">{name}</span>
      </div>
    </div>
  );
}
